
export type CommissionStatementModuleMode = 'plan' | 'execute';

export enum CommissionStatementModuleName {
  ApplyAndBackfill = 'apply-and-backfill',
  Discovery = 'discovery',
  PaymentsAndSplits = 'payments-and-splits',
}

export type CommissionStatementModuleType = {
  name: CommissionStatementModuleName;
  label: string;
  description: string;
  summary: string;
  available: boolean;
};

export const COMMISSION_STATEMENT_MODULE_TYPES: Array<CommissionStatementModuleType> = [
  {
    name: CommissionStatementModuleName.ApplyAndBackfill,
    label: 'Apply & Backfill',
    available: true,
    description: "The Apple & Backfill module tries to find policies and people in your database that match records on this commission statement. For those found, it applies the commission value to the policy and also backfills policy number if missing. It can also add new people and policies.",
    summary: "Tries to backfill policies and people in your database"
  },
  {
    name: CommissionStatementModuleName.Discovery,
    label: 'Discovery',
    available: false,
    description: "The discovery module compares your statement vs your database or other statements and discovers missing commission and people from the statement, allowing you to find drop-offs or cancellations.",
    summary: "Compares your statement vs your database"
  },
  {
    name: CommissionStatementModuleName.PaymentsAndSplits,
    label: 'Payments & Splits',
    available: false,
    description: "The Payments & Splits module uses your agent commission schedules to create a line item of what each agent should be paid. Great for payroll and override cuts.",
    summary: "Great for payroll and override cuts."
  },
];
